import React from 'react';
import Link from 'gatsby-link';
import classnames from 'classnames';
import styles from './styles.module.css';

import GridWrap from '../grid-wrap';

import HeritageLotteryFundLogo from '../../images/logos/hlf.png';
import HarrowCouncilLogo from '../../images/logos/harrow-council.png';
import MuseumLogo from '../../images/logos/museum.png';

export default ({ wrapped }) => (
  <div className={classnames(styles.container, { [styles.wrapped]: wrapped })}>
    <GridWrap>
      <div className={styles.inner}>
        <div className={styles.logos}>
          <span>Project brought to you by:</span>
          <div>
            <a href="https://www.hlf.org.uk/" target="_blank">
              <img src={HeritageLotteryFundLogo} alt="Heritage Lottery Fund" />
            </a>
            <a href="http://www.harrow.gov.uk/" target="_blank">
              <img src={HarrowCouncilLogo} alt="Harrow Council" />
            </a>
            <a href="http://headstonemanor.org/" target="_blank">
              <img src={MuseumLogo} alt="Headstone Manor and Museum" />
            </a>
          </div>
        </div>
        <div className={styles.bottom}>
          <ol className={styles.links}>
            {/* <li>
              <Link to="/">Terms of Use</Link>
            </li> */}
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/cookie-policy">Cookie Policy</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
          </ol>
          <div className={styles.copy}>Harrow Council © 2018</div>
        </div>
      </div>
    </GridWrap>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/site-footer/index.js